<template>
</template>

<script>
import { mapState } from 'vuex';
import { ensureGtmLoaded, pushEcommerceEvent,enrichItem } from 'assets/js/gtm';

export default {
    name: "PT506GTMViewCart",
    data() {
        return {
            eventSent: false,
        };
    },
    computed: {
        ...mapState('pt180', ['pt180Init']),
        cartItems() {
            return this.pt180Init && Array.isArray(this.pt180Init.searchList) ? this.pt180Init.searchList : [];
        },
        gtmContainerId() {
            return this.pt180Init && this.pt180Init.gtmcontainerId ? this.pt180Init.gtmcontainerId : '';
        },
        eventPayloadReady() {
            return !!this.gtmContainerId;
        }
    },
    watch: {
        eventPayloadReady: {
            handler(ready) {
                if (ready) {
                    this.$nextTick(() => {
                        this.cartItems.length && this.initAndPushViewCart();
                    });
                }
            },
            immediate: true,
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.cartItems.length && this.initAndPushViewCart();
        });
    },
    methods: {
        hasCartRoot() {
            return !!document.querySelector('#pt180');
        },
        canRunInContext() {
            return this.hasCartRoot();
        },
        initAndPushViewCart() {
            if (!this.eventPayloadReady || !this.canRunInContext()) {
                return;
            }
            this.$store.commit('setGtmId', this.gtmContainerId);
            ensureGtmLoaded();
            setTimeout(() => {
                this.pushViewCart();
            }, 200);
        },
        toNumber(value, fallback = 0) {
            const numeric = Number(value);
            return Number.isNaN(numeric) ? fallback : numeric;
        },
        buildCartItem(item = {}) {
            const quantity = this.toNumber(item.QTY, 1);
            return {
                item_id: item.M_ITEM_CD ,
                item_name: item.WEB_ITEM_NM ,
                quantity: quantity > 0 ? quantity : 1,
                price: item.SALE_TNK,
                ...( enrichItem(item.M_ITEM_CD) ? enrichItem(item.M_ITEM_CD) : {})
            };
        },
        pushViewCart() {
            if (this.eventSent || !this.eventPayloadReady || !this.canRunInContext()) {
                return;
            }

            // console.log("🚀 ~ this.cartItems:", this.cartItems)
            const items = this.cartItems.map(item => this.buildCartItem(item));
            const value = items.reduce((total, item) => {
                return total + (this.toNumber(item.price, 0) * this.toNumber(item.quantity, 1));
            }, 0);

            pushEcommerceEvent('view_cart', {
                currency: 'JPY',
                value,
                items,
            });
            this.eventSent = true;
        }
    }
}
</script>
